<div class="pnl-customers" [class.open]="open" infiniteScroll [fromRoot]="true" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="20" [infiniteScrollContainer]="selector" (scrolled)="onScroll()">
    <header>
        <h1>Clientes</h1>
        <button (click)="onExport()" type="button" class="btn btn-primary-outline"><i class="ic ic-export"></i> Exportar</button>
    </header>
    <section class="pnl">
        <ul class="tabs">
            <li class="todos" (click)="changeTab('todos')" [class.active]="tab=='todos'">
                <a>
                    <h4>{{num_todos}}</h4>
                    <strong>Todos</strong>
                </a>
            </li>
            <li class="detrator" (click)="changeTab('detrator')" [class.active]="tab=='detrator'">
                <a>
                    <span>{{num_detrator}}</span>
                    <strong>Detrator</strong>
                </a>
            </li>
            <li class="passivo" (click)="changeTab('passivo')" [class.active]="tab=='passivo'">
                <a>
                    <span>{{num_passivo}}</span>
                    <strong>Passivo</strong>
                </a>
            </li>
            <li class="promotor" (click)="changeTab('promotor')" [class.active]="tab=='promotor'">
                <a>
                    <span>{{num_promotor}}</span>
                    <strong>Promotor</strong>
                </a>
            </li>
            <li class="bloqueado" (click)="changeTab('bloqueado')" [class.active]="tab=='bloqueado'">
                <a>
                    <span>{{num_bloqueado}}</span>
                    <strong>Bloqueado</strong>
                </a>
            </li>
        </ul>
        <div class="customers" [class.todos]="tab=='todos'" [class.detrator]="tab=='detrator'" [class.passivo]="tab=='passivo'" [class.promotor]="tab=='promotor'" [class.bloqueado]="tab=='bloqueado'">
            <div *ngFor="let c of customers; let i=index" (click)="openDetail(c, i)" [class.active]="i==openid && c.idusuario == customer.idusuario" class="customer">
                <div class="col-acronym">
                    <span class="acronym">N</span>
                </div>
                <div class="descricao">
                    <strong>{{c.nome}}</strong>
                    <span>{{c.telefone}}</span>
                </div>
                <div class="status">
                    <b *ngIf="c.status == 'I'" class="bloqueado">Bloqueado</b>
                    <b *ngIf="c.nps && c.status != 'I'" [class.detrator]="c.nps <= 6" [class.passivo]="c.nps > 6 && c.nps < 9" [class.promotor]="c.nps >= 9">{{c.nps | number:'1.0-2'}}</b>
                </div>
            </div>
            <div class="customers-loading" *ngIf="loadingCustomer && !loadingTab">
                <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
                    <div class="ldio-ns36390yc">
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-loading" *ngIf="loadingTab">
            <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
                <div class="ldio-ns36390yc">
                    <div></div>
                </div>
            </div>
        </div>
    </section>
    <aside id="detailCustomer" class="detail" (scroll)="onScrolldetailCustomer($event)" [class.open-shopping]="openShopping" [class.open-evaluation]="openEvaluation">
        <form *ngIf="customer.idusuario > 0" [class.dnone]="customer.status=='I'" [formGroup]="customerFrm" (ngSubmit)="onSubmit()" novalidate>
            <header>
                <div class="btn-option" (click)="toggleOptions()" (mouseout)="hideOptions()" [class.open]="optionOpen">
                    <i></i>
                    <i></i>
                    <i></i>
                    <div (mouseover)="clearOptions()" (mouseout)="hideOptions()">
                        <a [routerLink]="['/app/cliente-cadastro/'+customer.idusuario]">{{customer.edita ? 'Editar cadastro' : 'Visualizar cadastro'}} <i class="ic ic-pen"></i></a>
                        <a class="dnone">Imprimir <i class="ic ic-print"></i></a>
                        <a (click)="blockCustomer()">Bloquear cliente <i class="ic ic-block"></i></a>
                    </div>
                </div>
                <a (click)="closeDetail()" class="btn-close"></a>
            </header>

            <section class="profile">
                <div class="picture" [class.detrator]="customer.nps && customer.nps < 7" [class.passivo]="customer.nps >= 7 && customer.nps < 9" [class.promotor]="customer.nps >= 9">
                    <span *ngIf="customer.nps" [ngClass]="getClassCustomerNPS(customer.nps_classificacao)">{{customer.nps_classificacao | number:'1.0-0'}}</span>
                    <div class="image">
                        <div>
                            <figure *ngIf="customer.imagem">
                                <img [src]="customer.imagem">
                            </figure>
                            <div *ngIf="!customer.imagem" class="acronym">
                                {{customer.nome.charAt(0)}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="identification">
                    <strong>{{customer.nome}}</strong>
                    <span>{{customer.cpf}}</span>
                </div>
            </section>

            <section class="grid">
                <div (click)="viewAllOrders()" class="cpointer">
                    <i class="ic ic-cart"></i>
                    <span>Compras</span>
                    <strong>{{customer.num_purchases}}</strong>
                </div>

                <div>
                    <i class="ic ic-ticket"></i>
                    <span>Ticket médio</span>
                    <b>R$ {{customer.average_ticket | number:'1.0-2'}}</b>
                </div>

                <div>
                    <i class="ic ic-refresh"></i>
                    <span>Recorrência</span>
                    <b>média de {{customer.recurrence}} {{customer.recurrence > 1 ? 'dias' : 'dia'}}</b>
                </div>
            </section>

            <section *ngIf="customer.evaluation && customer.evaluation.length > 0" class="evaluation">
                <div>
                    <h4>Últimas atualizações</h4>
                    <a (click)="viewAllEvaluation()" class="link">Todas avaliações</a>
                </div>

                <div *ngFor="let e of customer.evaluation; let i=index">
                    <b [class.detrator]="e.nps && e.nps <= 6" [class.passivo]="e.nps > 6 && e.nps < 9" [class.promotor]="e.nps >= 9">
                        {{e.nps}}
                    </b>
                    <div class="comments">
                        <span [class.italic]="e.descricao == ''">{{e.descricao==''?'Avaliou mas não comentou.':e.descricao}}</span>
                        <small [title]="e.dt_cadastro | date:'d/MM/y H:mm'">{{e.data}}</small>
                    </div>
                </div>
            </section>

            <footer id="footerContact" class="contact">
                <div *ngIf="customer.telefone != '' && customer.telefone != null" class="phones">
                    <a [href]="'https://wa.me/55'+cleanPhone(customer.telefone)" target="_blank" class="btn btn-green-outline">
                        <i class="ic ic-whatsapp"></i> Mensagem
                    </a>

                    <span>ou ligue <span>{{customer.telefone}}</span></span>
                </div>

                <div *ngIf="customer.addresses && customer.addresses.length > 0" class="addresses">
                    <div *ngFor="let address of customer.addresses; let a=index">
                        <span>
                            <i class="ic ic-pin"></i>
                        </span>
                        <div class="address">
                            <span><strong>{{address.bairro}}</strong>, {{address.cidade}} - {{address.uf}}</span>
                            <span>{{address.logradouro}}, {{address.numero}} {{address.complemento}}</span>
                            <span>CEP {{address.cep}}</span>
                        </div>
                    </div>
                </div>
            </footer>

            <button id="buttonContact" (click)="goToContact()" type="button" class="btn-contact" [class.hidden]="buttonContactHidden">Contatos</button>
        </form>

        <div class="shopping-history" infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="20" (scrolled)="onScrollOrders()">
            <header>
                <a (click)="closeViewAllOrders()">Perfil de {{customer.nome}}</a>

                <i class="ic ic-cart-history"></i>

                <h6>Histórico de compras</h6>
            </header>

            <section>
                <div *ngFor="let o of customer.orders; let i=index" [class.open]="o.open">
                    <a (click)="viewAllProducts(o)">
                        <span>Pedido n&ordm; {{o.idpedido}}</span>
                        <b><span *ngIf="o.idpedido_situacao != 8 && o.idpedido_situacao != 10">Em andamento</span></b>
                        <strong class="num">{{o.products.length}}</strong>
                        <strong class="dt">{{o.data | date:'dd/MM/y'}}</strong>
                    </a>
                    <ul>
                        <li *ngFor="let p of o.products; let j=index">
                            <span *ngFor="let emfalta of p.emfalta; let j=index" class="emfalta">
                                <span>
                                    {{emfalta.descricao}}
                                </span>
                                <b><i></i>Em falta</b>
                            </span>
                            <span>
                                <i *ngIf="p.emfalta && p.emfalta.length > 0" class="ic ic-arrow-right"></i>
                                <span>
                                    {{p.descricao}}
                                </span>
                                <b>{{p.quantidade}} x R$ {{p.preco}}</b>
                            </span>
                        </li>
                    </ul>
                </div>

                <section class="loading-intern" *ngIf="loadingDetailIntern">
                    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
                        <div class="ldio-ns36390yc">
                            <div></div>
                        </div>
                    </div>
                </section>
            </section>
        </div>

        <div class="evaluation" infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="20" (scrolled)="onScrollEvaluation()">
            <header>
                <a (click)="closeViewAllEvaluation()">Perfil de {{customer.nome}}</a>

                <i class="ic ic-evaluation"></i>

                <h6>Avaliações</h6>
            </header>

            <section>
                <div *ngFor="let e of customer.evaluations; let i=index" [class.open]="e.open">
                    <div class="comment">
                        <b [class.detrator]="e.nps && e.nps <= 6" [class.passivo]="e.nps > 6 && e.nps < 9" [class.promotor]="e.nps >= 9">{{e.nps}}</b>
                        <span>
                            <span [class.italic]="e.descricao == ''">{{e.descricao==''?'Avaliou mas não comentou.':e.descricao}}</span>
                            <small [title]="e.dt_cadastro | date:'d/MM/y H:mm'">{{e.data}}</small>
                        </span>
                        <a *ngIf="e.order" (click)="openDetailEvaluation(e)">detalhes do pedido</a>
                    </div>
                    <div *ngIf="e.order" class="order">
                        <header>
                            <strong>Pedido n&ordm; {{e.order.idpedido}}</strong>
                            <span>{{e.order.data | date:'dd/MM/y'}}</span>
                        </header>
                        <ul>
                            <li *ngFor="let p of e.order.products; let j=index">
                                <span *ngFor="let emfalta of p.emfalta; let j=index" class="emfalta">
                                    <span>
                                        {{emfalta.descricao}}
                                    </span>
                                    <b><i></i>Em falta</b>
                                </span>
                                <span>
                                    <i *ngIf="p.emfalta && p.emfalta.length > 0" class="ic ic-arrow-right"></i>
                                    <span>
                                        {{p.descricao}}
                                    </span>
                                    <b>{{p.quantidade}} x R$ {{p.preco}}</b>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <section class="loading-intern" *ngIf="loadingDetailIntern">
                    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
                        <div class="ldio-ns36390yc">
                            <div></div>
                        </div>
                    </div>
                </section>
            </section>
        </div>

        <div class="customer-blocked" [class.dflex]="customer.status=='I'">
          <div>
            <header>
                <a (click)="closeDetail()" class="btn-close"></a>
            </header>

            <section class="picture">
              <figure>
                <i class="ic ic-customer-blocked"></i>
              </figure>
              <strong>Cliente bloqueado</strong>

              <span>Bloqueado por <strong>{{customer.blocked_by}}</strong> em {{customer.blocked_date | date:'dd/MM/y'}}</span>
            </section>

            <section class="grid">
              <div>
                  <i class="ic ic-small-customer"></i>
                  <span><b>{{customer.nome}}</b>, CPF {{customer.cpf}}</span>
              </div>

              <div>
                  <i class="ic ic-phone"></i>
                  <span>{{customer.telefone}}</span>
              </div>

              <div>
                  <i class="ic ic-mail"></i>
                  <span>{{customer.email}}</span>
              </div>

              <div *ngIf="customer.addresses && customer.addresses.length > 0" class="addresses">
                <div *ngFor="let address of customer.addresses; let a=index">
                    <span>
                        <i class="ic ic-pin"></i>
                    </span>
                    <div class="address">
                        <span><strong>{{address.bairro}}</strong>, {{address.cidade}} - {{address.uf}}</span>
                        <span>{{address.logradouro}}, {{address.numero}} {{address.complemento}}</span>
                        <span>CEP {{address.cep}}</span>
                    </div>
                </div>
              </div>
            </section>
          </div>

          <footer>
            <button (click)="deleteCustomer()" type="button" class="btn btn-danger">Excluir cliente</button>

            <button (click)="unblockCustomer()" type="button" class="btn btn-green-outline">Desbloquear cliente</button>
          </footer>

        </div>

        <div class="customer-unblocked" [class.dflex]="showConfirmUnblocked">
          <i class="ic ic-success-confirm"></i>
          <strong>Desbloqueado com sucesso</strong>
        </div>

        <div class="customer-deleted" [class.dflex]="showConfirmDelete">
          <i class="ic ic-delete-confirm"></i>
          <strong>Excluído com sucesso</strong>
        </div>

        <div class="loading" *ngIf="loadingDetail">
            <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
                <div class="ldio-ns36390yc">
                    <div></div>
                </div>
            </div>
        </div>
    </aside>
</div>

<div *ngIf="isExportLoading" class="modal" [class.open]="modalExportOpen">
  <div class="modal-content modal-medium modal-export">
    <h3>Exportando...</h3>
    <div class="tab-loading">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
              <div></div>
          </div>
      </div>
    </div>
  </div>
</div>
